import { GlobalHeader } from "./../models/global-header.model";
import * as GlobalHeaderActions from "./../actions/global-header.actions";

const initialState: GlobalHeader = {
  globalSettings: {},
  globalAppSettings: {
    period_settings: {
      calendarization_method: "",
      ntm_stm_method: "",
    },
    addin_export_settings: {
      ticker_type: "",
      currency_compatible: "",
    },
  },
  menuOption: [],
  ssoSettings: {
    modelManagementLink: false,
    oneAccessLink: false,
  },
  notificationSettings: {
    notificationHost: "",
    userId: "",
    fetchNewData: false,
  },
  recentCompanies: [],
};

export function globalHeaderReducer(
  state: GlobalHeader = initialState,
  action: GlobalHeaderActions.Actions,
) {
  switch (action.type) {
    case GlobalHeaderActions.SET_MENU_OPTION:
      return {
        ...state,
        menuOption: action.payload,
      };
    case GlobalHeaderActions.SET_GLOBAL_SETTINGS:
      return {
        ...state,
        globalSettings: { ...action.payload },
      };
    case GlobalHeaderActions.SET_GLOBAL_APP_SETTINGS:
      return {
        ...state,
        globalAppSettings: { ...action.payload },
      };
    case GlobalHeaderActions.SET_ADDIN_EXPORT_SETTINGS:
      return {
        ...state,
        globalAppSettings: {
          ...state.globalAppSettings,
          addinExportSettings: { ...action.payload },
        },
      };
    case GlobalHeaderActions.SET_SSO_SETTINGS:
      return {
        ...state,
        ssoSettings: { ...action.payload },
      };
    case GlobalHeaderActions.SET_NOTIFICATION_SETTINGS:
      return {
        ...state,
        notificationSettings: {
          notificationHost: action.payload.notificationHost
            ? action.payload.notificationHost
            : state.notificationSettings.notificationHost,
          userId: action.payload.userId
            ? action.payload.userId
            : state.notificationSettings.userId,
          fetchNewData:
            action.payload.fetchNewData !== undefined
              ? action.payload.fetchNewData
              : state.notificationSettings.fetchNewData,
        },
      };
    case GlobalHeaderActions.SET_RECENT_COMPANIES:
      return {
        ...state,
        recentCompanies: [...action.payload],
      };
    case GlobalHeaderActions.UPDATE_RECENT_COMPANIES: {
      let recentComps = [];
      const existingIndex = state.recentCompanies.findIndex(
        (comp) => comp.sn === action.payload.ticker,
      );
      if (existingIndex !== -1) {
        const recentCompanies = [...state.recentCompanies];
        const existingComp = recentCompanies.splice(existingIndex, 1);
        recentComps = [...existingComp, ...recentCompanies];
      } else {
        const comp = {
          n: action.payload.company_name,
          sn: action.payload.ticker,
        };
        // if inactive company
        if (
          action.payload.dataCoverageTypeId === 5 ||
          action.payload["DataCoverageTypeId"] === 5
        ) {
          comp["c"] = 2;
        } else if (action.payload.status === "Models Only") {
          comp["c"] = 0;
        } else {
          comp["c"] = 1;
        }
        recentComps = [comp, ...state.recentCompanies];
      }
      recentComps = recentComps.slice(0, 48);
      return {
        ...state,
        recentCompanies: [...recentComps],
      };
    }
    default:
      return state;
  }
}
